import ContentElement from "./content-element.js";

const DEFAULT_ELEMENT_SELECTOR: string = '.th-fsc-magnet';

interface MagnetConfig {
    conditionSelector: string;
    itemSelector: string;
    closestSelector?: string;
    contextSelector?: string;
}

const defaultOptions: MagnetConfig = {
    conditionSelector: '',
    itemSelector: ''
};

class Magnet extends ContentElement {
    protected options: MagnetConfig;
    protected items:Map<HTMLElement, HTMLElement> = new Map();

    public override init() {
        this.options = this.assignConfig<MagnetConfig>(defaultOptions, this.config);
        Object.keys(this.options).forEach((pn) => {
            if(this.options[pn] !== null && this.options[pn].trim() === '' && this.element.dataset[pn] !== null) {
                this.options[pn] = this.element.dataset[pn];
            }
        });
    }

    public override process() {
        if(this.options.itemSelector) {
            let contextEl: HTMLElement = document.body;
            if(this.options.closestSelector && this.options.closestSelector !== '') {
                contextEl = this.element.closest<HTMLElement>(this.options.closestSelector)!;
            } else if(this.options.contextSelector && this.options.contextSelector !== '') {
                contextEl = document.querySelector<HTMLElement>(this.options.contextSelector)!;
            }
            if(contextEl) {
                contextEl.querySelectorAll<HTMLElement>(this.options.itemSelector)?.forEach((el: HTMLElement) => {
                    const placeholderEl = document.createElement('div');
                    placeholderEl.classList.add('magnet-placeholder');
                    el.before(placeholderEl);
                    this.items.set(el, placeholderEl);
                });
            }
        }

        window.addEventListener('resize', () => { this.update(); });
        window.addEventListener('orientationchanged', () => { this.update(); });
        window.addEventListener('load', () => { this.update(); });
    }

    protected update() {
        if(this.options.conditionSelector && this.items.size > 0) {
            const conditionEl: HTMLElement = document.querySelector<HTMLElement>(this.options.conditionSelector)!;
            if(conditionEl) {
                // Move to magnet
                this.items.forEach((placeholderEl: HTMLElement, itemEl: HTMLElement) => {
                    if(itemEl.parentElement !== this.element) {
                        this.element.appendChild(itemEl);
                    }
                });
            } else {
                // Move to initial position
                this.items.forEach((placeholderEl: HTMLElement, itemEl: HTMLElement) => {
                    if(itemEl.parentElement === this.element) {
                        placeholderEl.after(itemEl);
                    }
                });
            }
        }
    }

}

// Observe
Magnet.initializeDom(DEFAULT_ELEMENT_SELECTOR, true, true, true);

export type { MagnetConfig };
export default Magnet;
